(function () {
  window.vrvCartQualifiesFor1699Combo = function () { return Promise.resolve(false); };
  window.vrvEnsureComboSynced = function () { return Promise.resolve(); };
  return;
  const COMBO_PRICE_CENTS = 169900;
  const WORKER_URL = 'https://vervit-discount-sync.rishika-35d.workers.dev/combo-checkout-discount';
  let _isSyncing = false;
  let _lastCartItemsToken = '';
  let _syncRequested = false;
  let _syncPromise = null;
  let _loadingWatchdog = null;
  const CART_FETCH_TIMEOUT_MS = 10000;
  const COMBO_REQUEST_TIMEOUT_MS = 15000;

  function getComboFetch() {
    return (
      window.__vrvTrueNativeFetch ||
      window.__vrvNativeFetch ||
      (typeof window.fetch === 'function' ? window.fetch.bind(window) : null)
    );
  }

  function fetchWithTimeout(input, init, timeoutMs, label) {
    const fetchFn = getComboFetch();
    if (!fetchFn) return Promise.reject(new Error('Fetch is unavailable.'));

    const limit = Math.max(1000, Number(timeoutMs) || CART_FETCH_TIMEOUT_MS);
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const options = Object.assign({}, init || {});
    if (controller) options.signal = controller.signal;

    let timer;
    const timeout = new Promise((_, reject) => {
      timer = setTimeout(() => {
        if (controller) controller.abort();
        const error = new Error((label || 'Request') + ' timed out after ' + limit + 'ms.');
        error.code = 'VRV_COMBO_TIMEOUT';
        reject(error);
      }, limit);
    });

    return Promise.race([fetchFn(input, options), timeout]).finally(() => clearTimeout(timer));
  }

  function setDiscountUiLoading(isLoading) {
    if (_loadingWatchdog) {
      clearTimeout(_loadingWatchdog);
      _loadingWatchdog = null;
    }
    document.querySelectorAll('[data-vrv-cart-offers]').forEach((root) => {
      root.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      const loading = root.querySelector('[data-vrv-discount-loading]');
      if (loading) loading.hidden = !isLoading;
      root.querySelectorAll(':scope > .vrv-drawer__coupon-toolbar, :scope > .vrv-drawer__coupon-entry').forEach((content) => {
        content.hidden = isLoading;
      });
    });
    if (isLoading) {
      _loadingWatchdog = setTimeout(() => {
        _loadingWatchdog = null;
        console.error('[VRV COMBO] Loading watchdog released a stale offer/checkout loading state.');
        document.querySelectorAll('[data-vrv-cart-offers]').forEach((root) => {
          root.setAttribute('aria-busy', 'false');
          const loading = root.querySelector('[data-vrv-discount-loading]');
          if (loading) loading.hidden = true;
          root.querySelectorAll(':scope > .vrv-drawer__coupon-toolbar, :scope > .vrv-drawer__coupon-entry').forEach((content) => {
            content.hidden = false;
          });
        });
        if (typeof window.vrvSetCheckoutLoading === 'function') {
          window.vrvSetCheckoutLoading(false);
        }
      }, 20000);
    }
  }

  window.vrvSetCheckoutLoading = function(isLoading) {
    // FIX: this only looked at #CartDrawer-Checkout / #checkout, so the full
    // Cart PAGE's checkout button (id="CartPage-Checkout", class
    // "vrv-cart-page__checkout-btn") was NEVER disabled while a combo/spin
    // discount code was still silently syncing (see the 3.5s delay below).
    // A customer on the cart page could click through to Razorpay checkout
    // mid-sync and get whatever partial discount state Shopify happened to
    // have at that instant. Now every known checkout entry point is covered.
    const btns = [
      document.getElementById('CartDrawer-Checkout'),
      document.getElementById('CartPage-Checkout'),
      document.getElementById('checkout')
    ].filter(Boolean);
    if (!btns.length) return;
    btns.forEach(btn => {
      if (isLoading) {
        btn.disabled = true;
        if (!btn.dataset.originalHtml) {
          btn.dataset.originalHtml = btn.innerHTML;
        }
        if (!btn.querySelector('.vrv-coupon-spinner')) {
           btn.innerHTML = `<svg aria-hidden="true" focusable="false" class="spinner vrv-coupon-spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width: 20px; height: 20px; animation: spin 2s linear infinite; margin: 0 auto; display: block; color: currentColor;"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30" style="stroke: currentColor; stroke-dasharray: 187; stroke-dashoffset: 40;"></circle></svg>`;
        }
      } else {
        btn.disabled = false;
        if (btn.dataset.originalHtml) {
          btn.innerHTML = btn.dataset.originalHtml;
          delete btn.dataset.originalHtml;
        }
      }
    });
  };

  vrvLog('[VRV COMBO] Script loaded. Listening for cart updates.');
  // Clear stale Liquid/DOM state left by an older cached drawer section before
  // the first cart request starts. A spinner must represent a real request.
  setDiscountUiLoading(false);

  async function calculateCombo(cart) {
    const items = cart.items || [];
    console.log('[CHECKOUT DEBUG][COMBO] Step: calculateCombo() start. Cart item count:', items.length);

    // FIX: `eligible` used to store bare prices, so once a pair was picked
    // we had no way to say WHICH cart lines it came from. Now each entry
    // carries its variant_id too, so we can report exactly which lines the
    // discount is for (see `variantIds` below) instead of leaving Shopify to
    // guess (which is what caused it to also discount unrelated items).
    const eligible = [];
    const combos = {};
    let cartTotal = 0;
    let giftWrapTotal = 0;

    items.forEach((item, idx) => {
      const rawPrice = item.original_price;
      const price = Number(rawPrice);
      const isInvalidPrice = rawPrice == null || Number.isNaN(price);
      const isZeroPrice = !isInvalidPrice && price === 0;

      console.log(
        `[CHECKOUT DEBUG][COMBO] Item ${idx + 1}/${items.length}: "${item.title}" ` +
        `variant_id=${item.variant_id} qty=${item.quantity} ` +
        `original_price=${item.original_price} price=${item.price} ` +
        `final_line_price=${item.final_line_price} original_line_price=${item.original_line_price} ` +
        `properties=${JSON.stringify(item.properties || {})}`
      );

      if (isInvalidPrice) {
        console.error(
          '[CHECKOUT DEBUG][COMBO] Invalid price (null/undefined/NaN) on cart item -- this line cannot be priced or combo-evaluated correctly:',
          { title: item.title, variant_id: item.variant_id, key: item.key, original_price: rawPrice }
        );
      } else if (isZeroPrice) {
        console.warn(
          '[CHECKOUT DEBUG][COMBO] Zero (Rs.0) original_price on cart item -- likely a data issue on the variant (no price set, or a sample/draft variant), NOT something the combo calculation caused:',
          { title: item.title, variant_id: item.variant_id, key: item.key }
        );
      }

      if (item.properties && item.properties['VrvGiftWrap']) {
        console.log(`[CHECKOUT DEBUG][COMBO] -> classified as GIFT WRAP, excluded from combo. "${item.title}"`);
        giftWrapTotal += item.original_line_price;
        return;
      }
      cartTotal += item.original_line_price;

      if (isInvalidPrice) {
        console.log(`[CHECKOUT DEBUG][COMBO] -> excluded from combo pairing: invalid price. "${item.title}"`);
        return;
      }

      if (item.properties && item.properties['VrvComboId']) {
         const cid = item.properties['VrvComboId'];
         console.log(`[CHECKOUT DEBUG][COMBO] -> classified as EXPLICIT combo group "${cid}" (VrvComboId property). "${item.title}"`);
         if (!combos[cid]) combos[cid] = [];
         for (let q = 0; q < item.quantity; q++) {
           combos[cid].push({ price, variantId: item.variant_id });
         }
      } else if (item.title && item.title.toUpperCase().includes('COMBO')) {
         console.warn(
           `[CHECKOUT DEBUG][COMBO] -> classified as BUNDLED combo product by TITLE MATCH (title contains "COMBO"). ` +
           `This is a fragile heuristic: any unrelated product whose title happens to contain the word "combo" ` +
           `gets treated as an already-bundled item priced down to Rs.${COMBO_PRICE_CENTS / 100} here. "${item.title}" (variant ${item.variant_id}, price ${price / 100})`
         );
         for (let q = 0; q < item.quantity; q++) {
            const cid = 'custom_combo_' + item.key + '_' + q;
            if (!combos[cid]) combos[cid] = [];
            combos[cid].push({ price, variantId: item.variant_id, bundled: true });
         }
      } else if (price > 0 && price <= 149900) {
        console.log(`[CHECKOUT DEBUG][COMBO] -> classified as ELIGIBLE for pairing (price <= Rs.1499). "${item.title}"`);
        eligible.push({ price, variantId: item.variant_id, quantity: item.quantity });
      } else {
        console.log(`[CHECKOUT DEBUG][COMBO] -> NOT eligible for combo (price above Rs.1499 or invalid). "${item.title}"`);
      }
    });

    // FIX (root cause of "some products show Rs.0 / wrong combo price with
    // many products in the cart"): every qualifying pair -- whether an
    // explicit VrvComboId group, a title-matched bundle, a same-product
    // self-pair, or a cross-product leftover pair -- used to be dumped into
    // ONE global totalDiscountCents / discountedVariantIds accumulator and
    // sent to the worker as a SINGLE Shopify discount code amount scoped
    // across ALL of those variant_ids together.
    //
    // Shopify's discountAmount with appliesOnEachItem:false does not apply
    // "this slice of the amount to this pair, that slice to that pair" -- it
    // splits the ONE fixed amount PROPORTIONALLY BY PRICE across every
    // entitled line as a single pool (confirmed against Shopify's own docs:
    // a $50 discount on a $50 + $100 cart splits as $16.50 / $33.50, i.e.
    // proportional to price, not per logical "pair"). That is only
    // guaranteed to land every pair at exactly Rs.1699 when every pair in
    // the pool has the IDENTICAL pairTotal -- algebraically, for a group of
    // pairs that all sum to the same T, each unit's proportional share works
    // out to price_i * (1699/T), which sums back to exactly 1699 per pair
    // regardless of how many such pairs share the code. The moment two pairs
    // with DIFFERENT totals are combined into one amount, the math no longer
    // cancels out: a cheap pair gets under-discounted or over-discounted
    // relative to an expensive pair in the same pool, and with enough spread
    // between them the proportional share for the cheaper pair's units can
    // land at or near Rs.0 while the more expensive pair never reaches
    // Rs.1699 either. With a handful of same-priced products (the common
    // small-cart case) there's only ever one distinct pairTotal, so this was
    // invisible; with ~20 random, differently-priced products there are
    // usually several DIFFERENT pairTotals at once, which is exactly when
    // this breaks.
    //
    // Fix: collect every qualifying pair with its pairTotal, group pairs by
    // EXACT pairTotal (the only grouping that is mathematically guaranteed
    // safe under Shopify's proportional allocation), and only ever send ONE
    // such group -- the one with the largest total customer savings -- to
    // the worker as this cycle's discount. Any other, differently-priced
    // group found in the same cart is deliberately left un-discounted this
    // cycle (still logged clearly below) rather than silently mispriced.
    const allPairs = [];

    Object.keys(combos).forEach(cid => {
       const units = combos[cid].slice().sort((a, b) => b.price - a.price);
       const groupedAsSingleBundle = units.length === 1 && units[0].bundled;
       const pairCount = groupedAsSingleBundle ? 1 : Math.floor(units.length / 2);
       for (let pair = 0; pair < pairCount; pair++) {
         const pairUnits = groupedAsSingleBundle ? [units[0]] : units.slice(pair * 2, pair * 2 + 2);
         const pairTotal = pairUnits.reduce((sum, unit) => sum + unit.price, 0);
         const comboSavings = pairTotal - COMBO_PRICE_CENTS;
         if (comboSavings > 0) {
           allPairs.push({
             pairTotal,
             discount: comboSavings,
             variantIds: pairUnits.map(u => u.variantId).filter(Boolean),
             source: `explicit-combo:${cid}`,
           });
         }
       }
    });

    // FIX (qty>1 pairing bug): a Shopify discount code can only be scoped to
    // a whole variant, never to "N of the M units on this line" -- so if a
    // single line (e.g. 1 product at quantity 2) has only SOME of its units
    // paired, Shopify ends up discounting ALL of them anyway, which used to
    // silently over-discount a leftover unit and double the total discount
    // amount (this is what produced the "COMBO 1699 APPLIED" x3 / doubled
    // coupon-discount bug). To keep every variant we hand to the worker
    // 100% eligible (never partially), pair SAME-VARIANT units together
    // first (self-pairing consumes a line's quantity in exact multiples of
    // 2, so the whole thing stays whole-variant-safe), and only THEN pair
    // any single leftover unit across DIFFERENT products -- exactly like
    // before, just no longer racing ahead of quantity math.
    const leftovers = [];
    for (const line of eligible) {
       const selfPairs = Math.floor(line.quantity / 2);
       const remainder = line.quantity % 2;
       for (let i = 0; i < selfPairs; i++) {
          const pairTotal = line.price * 2;
          const pairDiscount = pairTotal - COMBO_PRICE_CENTS;
          if (pairDiscount > 0) {
             allPairs.push({
               pairTotal,
               discount: pairDiscount,
               variantIds: [line.variantId].filter(Boolean),
               source: 'self-pair',
             });
          }
       }
       if (remainder > 0) {
          leftovers.push({ price: line.price, variantId: line.variantId });
       }
    }

    leftovers.sort((a, b) => b.price - a.price);
    const pairsCount = Math.floor(leftovers.length / 2);
    for (let i = 0; i < pairsCount; i++) {
       const a = leftovers[i*2];
       const b = leftovers[i*2 + 1];
       const pairTotal = a.price + b.price;
       const pairDiscount = pairTotal - COMBO_PRICE_CENTS;
       if (pairDiscount > 0) {
          allPairs.push({
            pairTotal,
            discount: pairDiscount,
            variantIds: [a.variantId, b.variantId].filter(Boolean),
            source: 'cross-pair',
          });
       }
    }
    // NOTE: if `leftovers.length` is odd, the very last (lowest-price) entry
    // stays unpaired at full price -- correct, since there's genuinely no
    // partner left for it. The one still-imperfect edge case: a single line
    // with an ODD quantity >= 3 (e.g. qty 3 of the same product) and no
    // other leftover in the cart to pair its remainder with -- its self-paired
    // units are already safely discounted above, but Shopify still can't
    // exclude just that one remaining unit from an already-eligible variant,
    // so it would ride along at the discounted rate too. That's a genuine
    // Shopify Basic Code Discount limitation (no per-unit targeting); fixing
    // it fully would need a Shopify Function, not a theme/worker change.

    console.log(`[CHECKOUT DEBUG][COMBO] Found ${allPairs.length} qualifying pair(s) before grouping:`,
      allPairs.map(p => ({ pairTotal: p.pairTotal / 100, discount: p.discount / 100, variantIds: p.variantIds, source: p.source })));

    // Group pairs by EXACT pairTotal -- see the block comment above for why
    // this is the only grouping that is mathematically safe to combine into
    // one Shopify discount code.
    const groupsByTotal = new Map();
    allPairs.forEach(p => {
      const key = p.pairTotal;
      if (!groupsByTotal.has(key)) {
        groupsByTotal.set(key, { pairTotal: key, discount: 0, pairCount: 0, variantIds: new Set() });
      }
      const group = groupsByTotal.get(key);
      group.discount += p.discount;
      group.pairCount += 1;
      p.variantIds.forEach(v => group.variantIds.add(v));
    });

    let bestGroup = null;
    groupsByTotal.forEach((group) => {
      if (!bestGroup || group.discount > bestGroup.discount) bestGroup = group;
    });

    if (groupsByTotal.size > 1) {
      console.warn(
        '[CHECKOUT DEBUG][COMBO] Multiple DIFFERENT combo pair-price groups found in this cart. ' +
        'Shopify can only apply one fixed-amount discount code at a time, and combining pairs with ' +
        'different totals into one code would misprice them (see comment in calculateCombo()). ' +
        'Only the highest-savings group below will be discounted this cycle; the rest stay at full price:',
        Array.from(groupsByTotal.values()).map(g => ({
          pairTotal: g.pairTotal / 100,
          pairCount: g.pairCount,
          totalDiscount: g.discount / 100,
          variantIds: Array.from(g.variantIds),
          chosen: bestGroup === g,
        }))
      );
    }

    const totalDiscountCents = bestGroup ? bestGroup.discount : 0;
    const discountedVariantIds = bestGroup ? bestGroup.variantIds : new Set();
    const comboUsedTotal = bestGroup ? bestGroup.pairTotal * bestGroup.pairCount : 0;

    // NOTE (fix): this used to silently bolt on an extra "15% off whatever
    // else is in the cart" discount here (`remainingTotal * 0.15`), folded
    // invisibly into the same VRVCMBO_<amount> code. That made the combo
    // discount amount, and therefore the checkout total, depend on unrelated
    // items in the cart -- almost certainly why totals were sometimes
    // showing as Rs.999 / Rs.1299 instead of the flat Rs.1699. Removed so
    // this function ONLY discounts the actual combo pair(s)/group(s) down
    // to COMBO_PRICE_CENTS. If a blanket "15% off the rest" promo is really
    // wanted, it should be its own separate, visible, documented discount --
    // not silently merged into the combo price.
    //
    // NOTE (fix): a previous edit here tried to add the spin-wheel prize
    // back in by reading localStorage('vrv_spin_lead_v1') and regex-parsing
    // the prize text for a "Rs.NN" amount. That's fragile (stale/expired
    // leads, non-numeric prizes, a prize won on a totally different order)
    // and -- more importantly -- it can't tell whether that spin discount is
    // still actually applicable to *this* cart. That responsibility has been
    // moved to applyNativeCombo(), which reads the cart's own
    // `total_discount` (the REAL, currently-active discount Shopify is
    // applying right now) instead of guessing from localStorage. See the
    // `otherDiscountCents` logic below.

    console.log(
      `[CHECKOUT DEBUG][COMBO] calculateCombo() result: ${bestGroup ? bestGroup.pairCount : 0} pair(s) discounted, ` +
      `discountCents=${totalDiscountCents} (Rs.${totalDiscountCents / 100}), ` +
      `variantIds=[${Array.from(discountedVariantIds).join(',')}], ` +
      `usedTotalCents=${comboUsedTotal} (Rs.${comboUsedTotal / 100}), ` +
      `giftWrapTotal=${giftWrapTotal / 100}, cartTotal=${cartTotal / 100}`
    );

    return { discountCents: totalDiscountCents, variantIds: Array.from(discountedVariantIds), usedTotalCents: comboUsedTotal };
  }

  // FIX (stale/reused discount code -- root cause of "removing an unrelated
  // item snaps the combo price to a stale value"): must stay byte-for-byte
  // identical to the copy of this function in
  // assets/vrv-discount-sync-worker.js. The worker names each combo
  // discount code 'VRVCMBO_<amount>_<hash>', where <hash> is this function
  // applied to the sorted, deduped variant_id list the discount is scoped
  // to -- NOT just the amount. Previously the code name was
  // 'VRVCMBO_<amount>' alone, and because many different cart compositions
  // land on the exact same discount amount (lots of products share price
  // points), Shopify would reject re-creating a code whose name already
  // existed, the worker silently swallowed that error, and the OLD code --
  // still scoped to whichever variant_ids were in the cart the first time
  // that amount ever occurred -- got silently reused and reapplied to a
  // completely different, current cart. Computing the same fingerprinted
  // code name here lets `hasTargetCode` (below) correctly tell whether the
  // code already active on the cart actually matches the CURRENT cart's
  // exact combo composition, not just its discount amount.
  function vrvShortHash(str) {
    let h = 5381;
    for (let i = 0; i < str.length; i++) {
      h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
    }
    return h.toString(36).toUpperCase();
  }

  function vrvComboCodeFor(discountCents, variantIds) {
    const sorted = Array.from(new Set(
      (variantIds || []).map(Number).filter(v => Number.isInteger(v) && v > 0)
    )).sort((a, b) => a - b);
    const fingerprint = sorted.length > 0 ? sorted.join('-') : 'ALL';
    // V2 guarantees the worker creates a fresh non-combinable discount;
    // legacy codes may have been created with stacking enabled.
    return `VRVCMBO2_${discountCents}_${vrvShortHash(fingerprint)}`;
  }

  // FIX #2 (the previous fix used the wrong field): "is our combo currently
  // applied?" needs to read whatever this JS actually gets back from the
  // AJAX `/cart.js` endpoint -- NOT the Liquid `cart` drop, which is a
  // separate object with a separate schema even though both are named
  // `cart`. `cart.discount_applications` (used in the previous fix) is a
  // LIQUID-template-only field; it renders fine in snippets like
  // vrv-cart-totals.liquid because Liquid runs server-side against the
  // Liquid cart drop, but the JSON returned by fetch('/cart.js') here never
  // contained it, so `hasComboApplied` was STILL always false after that
  // fix -- for a different reason than before, but the same end result: a
  // stale, variant-scoped combo code could never be detected or cleared
  // once the eligible-item count dropped below 2.
  // `cart.discount_codes` (an array of { code, amount, applicable }) is a
  // core Cart object property that Shopify includes in EVERY `/cart.js`
  // response regardless of discount scope -- it's the literal list of
  // discount code strings currently entered on the cart, which is exactly
  // how this file applies its own code in the first place (see the
  // `fetch('/discount/' + data.code)` call below). It's also already used
  // successfully elsewhere in this codebase against the same AJAX cart
  // shape (assets/vrv-spin-wheel.liquid reads `data.discount_codes` from a
  // `/cart/update.js` response). Match by `.code`, not `.title` -- title
  // isn't a field on discount_codes entries at all.
  function vrvGetAppliedCodes(cart) {
    if (!cart) return [];
    // Prefer the AJAX API's literal code list. Mixing it with allocation
    // titles can represent one discount twice (code + friendly title), which
    // would falsely look like a stacked second coupon.
    if (Array.isArray(cart.discount_codes) && cart.discount_codes.length) {
      return Array.from(new Set(cart.discount_codes.map(d => String(d.code || '').toUpperCase()).filter(Boolean)));
    }
    const applications = []
      .concat(cart.cart_level_discount_applications || [])
      .concat(cart.discount_applications || []);
    (cart.items || []).forEach(item => {
      (item.line_level_discount_allocations || []).forEach(allocation => {
        if (allocation && allocation.discount_application) applications.push(allocation.discount_application);
      });
    });
    return Array.from(new Set(applications.map(d => String(d.code || d.title || '').toUpperCase()).filter(Boolean)));
  }

  function getCartItemsToken(cart) {
    if (!cart || !cart.items) return '';
    const itemsStr = cart.items.map(i => i.variant_id + ':' + i.quantity).join('|');
    const discountStr = vrvGetAppliedCodes(cart).join('|');
    return itemsStr + '-' + discountStr;
  }

  async function applyNativeCombo(cart) {
    const currentToken = getCartItemsToken(cart);
    vrvLog(`[VRV COMBO] Checking tokens. Current: ${currentToken} | Last: ${_lastCartItemsToken}`);
    if (currentToken === _lastCartItemsToken) {
       vrvLog('[VRV COMBO] Cart items token is unchanged. Skipping apply block.');
       return;
    }
    
    const comboResult = await calculateCombo(cart);
    const comboDiscountCents = comboResult.discountCents;
    const comboItemVariantIds = comboResult.variantIds;
    const hasComboApplied = vrvGetAppliedCodes(cart).some(code => code.includes('VRVCMBO') || code.includes('COMBO'));
    // The combo is exclusive. Its code replaces NEW15/any manual code and
    // contains only the exact savings required to price each eligible pair
    // at Rs.1699; no previous coupon amount is ever folded into it.
    const discountCents = comboDiscountCents;

    // Clear any falsely-persisted manual coupon UI state since the combo code will replace it
    let clearAttribute = false;
    if (comboDiscountCents > 0 && typeof window !== 'undefined') {
      try {
        if (cart && cart.attributes && cart.attributes['_vrv_active_coupon']) {
          clearAttribute = true;
        }
      } catch(e){}
    }

    vrvLog(`[VRV COMBO] Is combo applied? ${hasComboApplied}. Combo discount requested: ${discountCents}`);

    if (discountCents > 0) {
      const targetCode = vrvComboCodeFor(discountCents, comboItemVariantIds);
      const appliedCodesNow = vrvGetAppliedCodes(cart);
      const hasTargetCode = appliedCodesNow.includes(targetCode);
      if (hasTargetCode) {
         vrvLog('[VRV COMBO] Target code is already applied in cart. Updating token and returning.');
         _lastCartItemsToken = currentToken;
         return; 
      }
      
      vrvLog(`[VRV COMBO] Fetching discount code for target code ${targetCode}...`);
      console.log('[CHECKOUT DEBUG][COMBO] API request -> POST', WORKER_URL, {
        amount_cents: discountCents,
        amount_inr: discountCents / 100,
        variant_ids: comboItemVariantIds,
      });
      _isSyncing = true;
      try {
        // FIX: pass the exact variant_ids the discount is FOR, so the worker
        // can scope the generated code to just those products instead of
        // `items: { all: true }`. Without this, Shopify spreads the discount
        // amount across every eligible line in the cart -- including any
        // extra, unrelated product -- which silently undercharges the combo
        // lines and pins the unrelated product below its real price.
        const res = await fetchWithTimeout(WORKER_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ amount_cents: discountCents, variant_ids: comboItemVariantIds })
        }, COMBO_REQUEST_TIMEOUT_MS, 'Combo discount service');
        const data = await res.json();

        console.log('[CHECKOUT DEBUG][COMBO] API response <-', WORKER_URL, 'status=' + res.status, 'ok=' + res.ok, data);
        if (!res.ok) {
          console.error('[CHECKOUT DEBUG][COMBO] Worker returned a non-OK status for the combo discount request:', res.status, data);
        }
        vrvLog('[VRV COMBO] Worker response:', data);

        if (data.ok && data.code) {
            vrvLog('[VRV COMBO] Worker generated code. Syncing in background...', data.code);
            vrvLog('[VRV COMBO] Applying discount code silently in background:', data.code);
            // Apply silently without refreshing the cart drawer (UI is already optimistically correct!)
            try {
              const discountResponse = await fetchWithTimeout(
                '/discount/' + encodeURIComponent(data.code),
                { credentials: 'same-origin', cache: 'no-store' },
                CART_FETCH_TIMEOUT_MS,
                'Shopify discount application'
              );
              const nonComboCodes = vrvGetAppliedCodes(cart).filter(c => c && !c.includes('VRVCMBO') && !c.includes('COMBO'));
              const combinedCodes = [data.code].concat(nonComboCodes);
              const payload = { discount: combinedCodes.join(',') };
              if (clearAttribute) {
                payload.attributes = { '_vrv_active_coupon': '' };
              }
              console.log('[CHECKOUT DEBUG][COMBO] API request -> POST /cart/update.js', payload);
              const updateResponse = await fetchWithTimeout('/cart/update.js', {
                 method: 'POST',
                 credentials: 'same-origin',
                 headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                 body: JSON.stringify(payload)
               }, CART_FETCH_TIMEOUT_MS, 'Shopify combo cart update');
              if (!updateResponse.ok) throw new Error('Shopify rejected the combo cart update.');
              let fresh = await updateResponse.json();
              console.log('[CHECKOUT DEBUG][COMBO] API response <- /cart/update.js status=' + updateResponse.status,
                { discount_codes: fresh && fresh.discount_codes, total_price: fresh && fresh.total_price, item_count: fresh && fresh.item_count });
              if (!vrvGetAppliedCodes(fresh).includes(String(data.code).toUpperCase())) {
                fresh = await fetchCurrentCart();
              }
              if (!vrvGetAppliedCodes(fresh).includes(String(data.code).toUpperCase())) {
                console.error('[CHECKOUT DEBUG][COMBO] Combo discount code was NOT confirmed as applied by Shopify after /cart/update.js. Applied codes now:', vrvGetAppliedCodes(fresh));
                throw new Error('Combo discount was not confirmed by Shopify.');
              }
              // FIX (visibility for "some products show Rs.0 with the combo
              // applied"): log the ACTUAL post-discount price Shopify computed
              // for every entitled line, so a mismatch between the intended
              // Rs.1699-per-pair price and what Shopify's own proportional
              // allocation produced is visible immediately instead of only
              // showing up as a silent price discrepancy in the UI.
              try {
                const entitled = new Set((comboItemVariantIds || []).map(String));
                (fresh.items || []).forEach((line) => {
                  if (!entitled.has(String(line.variant_id))) return;
                  const finalEach = line.quantity ? line.final_line_price / line.quantity : line.final_line_price;
                  console.log(
                    `[CHECKOUT DEBUG][COMBO] Post-discount check: "${line.title}" variant=${line.variant_id} qty=${line.quantity} ` +
                    `original_price=${line.original_price} final_price_per_unit=${finalEach} final_line_price=${line.final_line_price}`
                  );
                  if (Number(finalEach) === 0) {
                    console.error(
                      `[CHECKOUT DEBUG][COMBO] Rs.0 final price detected on a combo-entitled line after Shopify applied the discount code. ` +
                      `This means Shopify's proportional split across the entitled variant set did not distribute the amount as intended -- ` +
                      `re-check that every entitled pair in this code shares the exact same pairTotal (see calculateCombo grouping).`,
                      { title: line.title, variant_id: line.variant_id, code: data.code }
                    );
                  }
                });
              } catch (logErr) {
                console.warn('[CHECKOUT DEBUG][COMBO] Could not run post-discount price check', logErr);
              }
              // Refresh _lastCartItemsToken from the authoritative cart snapshot so future diffs are accurate
              try {
                _lastCartItemsToken = getCartItemsToken(fresh);
                if (typeof window.vrvSyncCartPricingUI === 'function') {
                  window.vrvSyncCartPricingUI(fresh);
                }
                const drawer = document.querySelector('cart-drawer');
                if (drawer && typeof drawer.refreshDrawer === 'function') {
                  await drawer.refreshDrawer(true);
                }
              } catch (e) {
                _lastCartItemsToken = currentToken;
              }
              // Update coupon UI to hide conflicting coupons like NEW15 when combo is active
              try { updateCouponUIForCombo(true); } catch (e) {}
            } catch(e) {
              console.error('[VRV COMBO] Could not confirm combo application', e);
              throw e;
            }

            // Intentionally skipping window.vrvApplyDiscount(data.code) to avoid double UI refresh
          } else if (!data.ok) {
          throw new Error(data.error || 'Combo discount service failed.');
        } else {
          throw new Error('Combo discount service returned no code.');
        }
      } catch (e) {
        console.error('[VRV COMBO] Apply error', e);
        throw e;
      } finally {
        _isSyncing = false;
      }

    } else {
      if (hasComboApplied) {
        vrvLog('[VRV COMBO] No discount to apply, but combo is active. Removing combo...');
        _isSyncing = true;
        try {
          _lastCartItemsToken = currentToken;
          await fetchWithTimeout(
            '/discount/CLEAR',
            { credentials: 'same-origin', cache: 'no-store' },
            CART_FETCH_TIMEOUT_MS,
            'Shopify combo removal'
          );
          const clearResponse = await fetchWithTimeout('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: '' })
          }, CART_FETCH_TIMEOUT_MS, 'Shopify combo cart cleanup');
          if (!clearResponse.ok) throw new Error('Shopify rejected combo removal.');
          const fresh = await clearResponse.json();
          if (vrvGetAppliedCodes(fresh).some(c => c.includes('VRVCMBO') || c.includes('COMBO'))) {
            throw new Error('Shopify did not clear the stale combo discount.');
          }
          _lastCartItemsToken = getCartItemsToken(fresh);
          if (typeof window.vrvSyncCartPricingUI === 'function') window.vrvSyncCartPricingUI(fresh);
          try { updateCouponUIForCombo(false); } catch (e) {}
          // Clear any combo-blocked auto-apply flags so coupons can re-apply later
          try {
            if (window && window.sessionStorage) {
              const raw = window.sessionStorage.getItem('_vrv_combo_blocked_codes');
              if (raw) {
                const arr = JSON.parse(raw || '[]') || [];
                arr.forEach((c) => {
                  try {
                    window.sessionStorage.removeItem('vrvAutoApplyBlocked:' + c);
                    window.sessionStorage.removeItem('vrvAutoApply:' + c);
                  } catch (_) {}
                });
              }
              window.sessionStorage.removeItem('_vrv_combo_blocked_codes');
            }
          } catch (_) {}
        } catch (e) {
          console.error('[VRV COMBO] Remove error', e);
        } finally {
          _isSyncing = false;
        }
      } else {
         _lastCartItemsToken = currentToken;
      }
    }
  }

  // FIX (root cause of cart/checkout price mismatch): this is the single
  // authoritative "is the combo discount correct for the CURRENT cart right
  // now?" check. Previously the only thing standing between a customer and
  // checkout was a document-level click gate (removed below) that only
  // blocked navigation while `_isSyncing` happened to already be true --
  // it never actually forced a check, so a cart mutation that hadn't been
  // picked up by the cart mutation hook / `cart:updated` listener
  // yet could slip through with a stale discount code still applied, and
  // that same gate finished by hard-navigating to plain `/checkout`,
  // bypassing the Razorpay Magic Checkout flow entirely.
  //
  // Called from launchRazorpayCartCheckout() (assets/cart-drawer-extras.js)
  // right before it fetches the cart it hands to Razorpay, so checkout can
  // no longer open against a cart whose combo discount hasn't caught up yet
  // -- and when the cart is already correctly synced (the common case) this
  // resolves immediately with no artificial delay.
  async function fetchCurrentCart() {
    const response = await fetchWithTimeout('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }, CART_FETCH_TIMEOUT_MS, 'Shopify cart fetch');
    if (!response.ok) throw new Error('Cart fetch failed (' + response.status + ')');
    try {
      return await response.json();
    } catch (error) {
      throw new Error('Shopify cart returned invalid JSON.');
    }
  }

  // All triggers feed one serialized drain. If the cart changes while the
  // worker/code application is in flight, _syncRequested remains true and
  // the loop immediately processes a fresh authoritative cart afterwards.
  // No add/remove/quantity event is dropped and concurrent codes cannot win
  // in a different order from the cart mutations that caused them.
  function requestComboSync() {
    _syncRequested = true;
    if (_syncPromise) {
      console.log('[CHECKOUT DEBUG][COMBO] requestComboSync() called while a sync is already in flight -- flagged for another pass, not starting a duplicate.');
      return _syncPromise;
    }

    console.log('[CHECKOUT DEBUG][COMBO] requestComboSync() starting a new sync run.');
    _syncPromise = (async () => {
      _isSyncing = true;
      let loadingShown = false;
      let iteration = 0;
      try {
        while (_syncRequested) {
          iteration += 1;
          _syncRequested = false;
          console.log(`[CHECKOUT DEBUG][COMBO] Sync iteration ${iteration}: fetching current cart...`);
          const cart = await fetchCurrentCart();
          console.log(`[CHECKOUT DEBUG][COMBO] Sync iteration ${iteration}: cart fetched. item_count=${cart.item_count}, total_price=${cart.total_price}, discount_codes=${JSON.stringify(vrvGetAppliedCodes(cart))}`);
          const preview = await calculateCombo(cart);
          const comboIsApplied = vrvGetAppliedCodes(cart).some((code) =>
            code.includes('VRVCMBO') || code.includes('COMBO')
          );
          if (!loadingShown && (preview.discountCents > 0 || comboIsApplied)) {
            loadingShown = true;
            window.vrvSetCheckoutLoading(true);
            setDiscountUiLoading(true);
          }
          await applyNativeCombo(cart);
          console.log(`[CHECKOUT DEBUG][COMBO] Sync iteration ${iteration}: applyNativeCombo() finished. _syncRequested (retrigger during this iteration)=${_syncRequested}`);
        }
        console.log(`[CHECKOUT DEBUG][COMBO] requestComboSync() converged after ${iteration} iteration(s).`);
      } catch (error) {
        console.error('[CHECKOUT DEBUG][COMBO] requestComboSync() failed:', error);
        throw error;
      } finally {
        _isSyncing = false;
        _syncPromise = null;
        if (loadingShown) window.vrvSetCheckoutLoading(false);
        // Never leave the drawer in a blocking intermediate state. Errors are
        // reported to the caller/console, while the last Shopify-confirmed
        // offer UI remains usable and checkout is re-enabled.
        setDiscountUiLoading(false);
      }
    })();
    return _syncPromise;
  }

  window.vrvEnsureComboSynced = requestComboSync;

  // Cart renderers call this hook after Shopify confirms an add/change but
  // before they paint/open the drawer. Reconcile the real cart here so the
  // second eligible item can never render with a previously-active NEW15.
  // Preserve any pre-existing hook because this is a shared theme extension
  // point used by all add-to-cart implementations.
  const previousBeforeCartRender = window.vrvBeforeCartRender;
  window.vrvBeforeCartRender = async function (cartMutationResponse) {
    const response = typeof previousBeforeCartRender === 'function'
      ? await previousBeforeCartRender(cartMutationResponse)
      : cartMutationResponse;
    await requestComboSync();
    return response;
  };

  window.vrvCartQualifiesFor1699Combo = async function (cart) {
    const current = cart && Array.isArray(cart.items) ? cart : await fetchCurrentCart();
    return (await calculateCombo(current)).discountCents > 0;
  };

  function queueComboSyncFromCartFetch() {
    vrvLog('[VRV COMBO] Cart updated; synchronizing combo.');
    return requestComboSync().catch((err) => {
      console.warn('[VRV COMBO] Cart sync failed', err);
    });
  }

  document.addEventListener('cart:updated', queueComboSyncFromCartFetch);
  window.addEventListener('pageshow', queueComboSyncFromCartFetch);

  function vrvLog(msg, data) {
    console.warn(msg, data || '');
  }

  // UI helper: hide or show NEW15 coupon cards in the coupons list so the
  // drawer doesn't show conflicting coupons while a combo is active.
  function updateCouponUIForCombo(active) {
    // NEW15 is stackable with combo; keep all coupon cards and badges visible
    return;
  }

  function startCombo() {
    vrvLog('[VRV COMBO] startCombo executing.');

    // Cart changes already enter the serialized sync through
    // vrvBeforeCartRender, cart:updated and pageshow. Observing every DOM
    // mutation here also observed our own checkout/loading spinner markup,
    // which recursively requested another sync and could keep loading alive
    // forever. Do not use DOM changes as cart-state signals.
    requestComboSync().catch(err => {
      console.warn('[VRV COMBO] Initial cart sync failed', err);
    });
  }
  
  startCombo();
})();

if (!window.vrvRemoveCombo) {
  window.vrvRemoveCombo = function(btn) {
    const keys = btn.getAttribute('data-keys').split(',').filter(Boolean);
    if (!keys.length) return;
    
    const originalText = btn.innerHTML;
    btn.innerHTML = '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width: 16px; height: 16px; animation: spin 2s linear infinite;"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30" style="stroke: currentColor; stroke-dasharray: 187; stroke-dashoffset: 40;"></circle></svg>';
    btn.style.opacity = '0.5';
    btn.style.pointerEvents = 'none';
    
    const updates = {};
    keys.forEach(k => updates[k] = 0);
    
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(res => res.json())
    .then(cart => {
       const drawer = document.querySelector('cart-drawer');
       if (drawer && typeof drawer.refreshDrawer === 'function') {
          // FIX: forceFresh=true -- this just zeroed out the combo line quantities via
          // /cart/update.js, so a stale hover-prefetched drawer snapshot must not be
          // shown (it would still display the removed combo items).
          drawer.refreshDrawer(true).finally(() => {
             btn.innerHTML = originalText;
             btn.style.opacity = '1';
             btn.style.pointerEvents = 'auto';
          });
       } else {
          window.location.reload();
       }
    })
    .catch(e => {
       console.error(e);
       btn.innerHTML = originalText;
       btn.style.opacity = '1';
       btn.style.pointerEvents = 'auto';
    });
  };
}

// FIX (root cause of cart/checkout price mismatch, part 2): this used to be
// a second, independent checkout-click gate living here on `document`
// (capture phase), separate from the real Razorpay Magic Checkout launcher
// in assets/vrv-magic-checkout.js / assets/cart-drawer-extras.js. Because a
// document-level capture listener always fires before a listener bound
// directly to the button, this gate ran FIRST on every checkout click --
// and whenever it happened to catch `_isSyncing === true`, it called
// e.stopPropagation(), which stopped the click from ever reaching the real
// launcher's button listener at all. Once its own wait finished it
// hard-navigated to plain `/checkout` (`window.location.href = '/checkout'`),
// completely bypassing Razorpay Magic Checkout for that customer -- a
// different checkout experience than the rest of the site, decided purely
// by which millisecond they happened to click on.
//
// The wait-for-correct-total behavior this gate existed for is now done
// properly inside launchRazorpayCartCheckout() itself (via
// window.vrvEnsureComboSynced, defined above), which is the SAME function
// every real checkout entry point on the site already funnels through. That
// makes checkout deterministically wait for (and actively trigger, not just
// hope a background listener already caught) the correct combo total before
// ever fetching the cart Razorpay checks out with -- no second gate needed.
